import React, { Component } from 'react';
import { string } from 'prop-types';

import SVG from 'common/SVG/SVG';

import { CREDIT_CARD_REGEXES } from 'common/constants';

import styles from './CreditCardList.css';

export default class CreditCardList extends Component {
  static propTypes = {
    value: string.isRequired
  };

  constructor() {
    super();

    this.allCards = [
      'Visa',
      'Mastercard',
      'AmericanExpress',
      'RuPay'
    ];

    this.currentCardList = [
      'Visa',
      'Mastercard',
      'AmericanExpress',
      'RuPay'
    ];    
  }

  validateRuPay = (inputValue, { card, subPatterns, length }) => {
    // RuPay card edge case
    if (
      inputValue.length
      && (
        subPatterns[0].test(inputValue.substr(0,3))
        || subPatterns[1].test(inputValue.substr(0,4))
      )
      && inputValue.length < length
    ) {
      this.currentCardList = this.currentCardList.filter(elem => elem === card);

      return true;
    } else {
      return false;
    }
  }

  filterCreditCardList = inputValue => {
    const maxLength = CREDIT_CARD_REGEXES.length;
    let i = 0;
    let ccMatched = false;

    while(i < maxLength && !ccMatched) {
      const { card, subPatterns, length } = CREDIT_CARD_REGEXES[i];

      if (card === 'RuPay') {
        ccMatched = this.validateRuPay(inputValue, CREDIT_CARD_REGEXES[i]);
      } else if (
        inputValue.length
        && subPatterns[0].test(inputValue[0])
        && subPatterns[1].test(inputValue.substr(0, 2))
        && inputValue.length < length
      ) {
        this.currentCardList = this.currentCardList.filter(elem => elem === card);

        ccMatched = true;
      } else {
        this.currentCardList = [...this.allCards];
      }

      i++;
    }
  }

  render() {
    const { value } = this.props;

    this.filterCreditCardList(value);

    return (
      <ul className={styles.ccList}>
        {this.currentCardList.map((cc, i) =>
          <li key={`svg-${i}`}>
            <SVG filePath={'assets/svgs/ccp/30'} id={cc} width={30} height={30} />
          </li>
        )}
      </ul>
    );
  }
}


// WEBPACK FOOTER //
// ./src/uis/common/CreditCardList/CreditCardList.js